import { JSX } from 'react';
import './FlexibleContentTile.scss';

interface FlexibleContentTileProps {
  children: JSX.Element[];
  isContentTile?: boolean;
  tileClass?: string;
}

const FlexibleContentTile = (props: FlexibleContentTileProps) => {
  if (props) {
    return (
      <div
        data-cs-mask // IMPORTANT: DO NOT REMOVE data-cs-mask attribute, this ensures the PII data is masked correctly for session replay
        className={`flexible-content-tile-container ${props.tileClass} ${props.isContentTile ? 'no-data-tile' : ''}`}
      >
        <div className="tile-child">
          <div className="flexcontenttile-first-child-container">{props.children[0]}</div>
        </div>
        {props.children[1] ? <div className="tile-child">{props.children[1]}</div> : <></>}
      </div>
    );
  } else {
    return <></>;
  }
};

export default FlexibleContentTile;
